<img [alt]="altText()" [className]="className()" [src]="link" />
